const state = {
    company:{name:''},
};

const getters = {
    getCompany: state => state.company,
};

const actions = {
    setCompany: (store, payload) => store.commit("COMPANY_SET",payload),
};

const mutations = {
    COMPANY_SET: (state, payload) => state.company = payload,
};

export default {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
